// extracted by mini-css-extract-plugin
export default {"whole":"Fraction_whole__KRpTa"};